import React from 'react';
import CurrentStatus from "../CurrentStatus/CurrentStatus";
import Graph from "../Graph/Graph";
import PostGraph from "../Graph/PostGraph";
import TvrGraph from "../Graph/TvrGraph";
import ActiveChannelTable from "../Table/ActiveChannelTable";
import ActiveUserTable from "../Table/ActiveUserTable";
import Map from "../Map/Map";
import { useState, useEffect } from "react";
import axiosConfig from "../axiosConfig";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS } from 'chart.js/auto';
import Header from '../Header/Header';
import MainMenu from '../MainMenu/MainMenu';
import Cookies from 'universal-cookie';
import { localeData } from 'moment/moment';
import { configure } from '@testing-library/react';
import axiosConfigDotNet from '../axiosConfigDotNet';


const OverviewOPT = () => {
    const cookies = new Cookies();
    const [lastUpdatedDate, setLastUpdatedDate] = useState("");

    function pad(n) {
        return n < 10 ? '0' + n : n
    }

    if (cookies.get('_role') === "admin" || cookies.get('_role') === "operator") {
        var today = new Date(),
            role_datetime = today.getFullYear() + '-' + pad((today.getMonth() + 1)) + '-' + pad(today.getDate()) + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    } else if (cookies.get('_role') === "general" || cookies.get('_role') === "add-agency") {
        var last_updated_date = new Date(lastUpdatedDate);
        var role_datetime = last_updated_date.getFullYear() + '-' + pad((last_updated_date.getMonth() + 1)) + '-' + pad(last_updated_date.getDate()) + ' 23:59:59';
    }

    // console.log(new Date(lastUpdatedDate));
    // console.log(role_datetime);

    const [start, setStart] = useState("");
    const [finish, setFinish] = useState("");
    const [userType, setUserType] = useState("STB");
    const [selectedTargetGroup, setSelectedTargetGroup] = useState("All");
    //const [region, setRegion] = useState(["Dhaka", "Chattogram", "Rajshahi", "Sylhet", "Mymensingh", "Khulna", "Rangpur", "Barishal"]);
    const [region, setRegion] = useState(["Dhaka", "Dhaka Rural", "Chattogram"]);
    const [gender, setGender] = useState("");
    const [economic, setEconomic] = useState(["a", "b", "c", "d"]);
    // const [socio, setSocio] = useState("");
    const allAgeGroups = ["4-14", "15-24", "25-34", "35-44", "45 & Above"];
    const [ageGroup, setAgeGroup] = useState(allAgeGroups);
    const [others, setOthers] = useState(false);
    const [anyChannel, setAnyChannel] = useState(false);
    const [err, setErr] = useState("error");
    const [loading, setloading] = useState(false);
    const [inputData, setInputData] = useState({});
    const [outputData, setOutputData] = useState(null);
    const [channelDataReachUniverse, setChannelDataReachUniverse] = useState({
        labels: [],
        datasets: []
    });
    const [channelDataReachPercentage, setChannelDataReachPercentage] = useState({
        labels: [],
        datasets: []
    });
    const [channelDataTVR000, setChannelDataTVR000] = useState({
        labels: [],
        datasets: []
    });
    const [channelDataTVRPercent, setChannelDataTVRPercent] = useState({
        labels: [],
        datasets: []
    });
    const [channelDataTVRSharePercent, setChannelDataTVRSharePercent] = useState({
        labels: [],
        datasets: []
    });
    const [channelDataTimeSpentUniverseMinute, setChannelDataTimeSpentUniverseMinute] = useState({
        labels: [],
        datasets: []
    });
    const [channelDataTimeSpentViewer, setChannelDataTimeSpentViewer] = useState({
        labels: [],
        datasets: []
    });
    const [savedFilters, setSavedFilters] = useState([]);
    const [showSavePopup, setShowSavePopup] = useState(false);
    const [saveFilterName, setSaveFilterName] = useState("");
    const [saveSaving, setSaveSaving] = useState(false);
    const [saveError, setSaveError] = useState("");
    const [deleteSaving, setDeleteSaving] = useState(false);

    const barOptions = {
        responsive: true,
        maintainAspectRatio: false,
        title: {
            display: true,
            text: "Channels",
            fontSize: 1
        },
        legend: {
            display: true,
            position: 'right'
        },
        plugins: {
            legend: {
                display: false
            },
            datalabels: {
                display: false
            }
        }
    };


    const handleCheckboxChangeAgeGroup = (event) => {
        const value = event.target.value;
        setAgeGroup(prevState => {
            const newState = [...prevState];
            const index = newState.indexOf(value);
            if (index === -1) {
                newState.push(value);
            } else {
                newState.splice(index, 1);
            }
            return newState;
        });
    }

    const handleCheckboxChangeEconomic = (event) => {
        const value = event.target.value;
        setEconomic(prevState => {
            const newState = [...prevState];
            const index = newState.indexOf(value);
            if (index === -1) {
                newState.push(value);
            } else {
                newState.splice(index, 1);
            }
            return newState;
        });
    }

    const region_lock_date = new Date("2024-08-15T23:59:59").getTime();                     // 15th August 2024 only Dhaka and Chattogram will be available
    const isRegionDisabled = new Date(start).getTime() > region_lock_date || new Date(finish).getTime() > region_lock_date;

    const dhakaRural_region_lock_date = new Date("2025-02-01T00:00:00").getTime();                     // 15th August 2024 only Dhaka and Chattogram will be available
    const dhakaRural_isRegionDisabled = new Date(start).getTime() < dhakaRural_region_lock_date || new Date(finish).getTime() < dhakaRural_region_lock_date;

    useEffect(() => {
        setRegion((prevState) => {
            let updatedRegions = [...prevState];

            // Apply the general region condition
            if (isRegionDisabled) {
                updatedRegions = updatedRegions.filter(value => value === "Dhaka" || value === "Dhaka Rural" || value === "Chattogram");
            }

            // Apply the Dhaka Rural-specific condition
            if (dhakaRural_isRegionDisabled) {
                updatedRegions = updatedRegions.filter(value => value !== "Dhaka Rural");
            }

            return updatedRegions;
        });
    }, [isRegionDisabled, dhakaRural_isRegionDisabled]);

    const handleCheckboxChangeRegion = (event) => {
        const value = event.target.value;
        setRegion(prevState => {
            const newState = [...prevState];
            const index = newState.indexOf(value);
            if (index === -1) {
                newState.push(value);
            } else {
                newState.splice(index, 1);
            }
            return newState;
        });
    }

    const getAllRegions = () => {
        let list = ["Dhaka", "Dhaka Rural", "Chattogram", "Rajshahi", "Sylhet", "Mymensingh", "Khulna", "Rangpur", "Barishal"];
        if ((start && finish && isRegionDisabled) || (!start && !finish)) {
            list = list.filter(value => value === "Dhaka" || value === "Dhaka Rural" || value === "Chattogram");
        }
        if (dhakaRural_isRegionDisabled) {
            list = list.filter(value => value !== "Dhaka Rural");
        }
        return list;
    };

    const getUrbanRegions = () => {
        return getAllRegions().filter(value => value !== "Dhaka Rural");
    };

    const handleTargetGroupChange = (event) => {
        const value = event.target.value;
        setSelectedTargetGroup(value);

        if (value.startsWith("saved_")) {
            const filterId = value.replace("saved_", "");
            const selectedFilter = savedFilters.find((item) => String(item.id) === filterId);
            applySavedFilter(selectedFilter);
            return;
        }

        switch (value) {
            case "All":
                setRegion(getAllRegions());
                setAgeGroup(allAgeGroups);
                setGender("");
                setEconomic(["a", "b", "c", "d"]);
                setOthers(false);
                setAnyChannel(false);
                break;
            case "All Urban":
                setRegion(getUrbanRegions());
                setAgeGroup(allAgeGroups);
                setGender("");
                setEconomic(["a", "b", "c", "d"]);
                setOthers(false);
                setAnyChannel(false);
                break;
            case "All Rural":
                setRegion(["Dhaka Rural"]);
                setAgeGroup(allAgeGroups);
                setGender("");
                setEconomic(["a", "b", "c", "d"]);
                setOthers(false);
                setAnyChannel(false);
                break;
            case "All 15+":
                setRegion(getAllRegions());
                setAgeGroup(["15-24", "25-34", "35-44", "45 & Above"]);
                setGender("");
                setEconomic(["a", "b", "c", "d"]);
                setOthers(false);
                setAnyChannel(false);
                break;
            case "All Male":
                setRegion(getAllRegions());
                setAgeGroup(allAgeGroups);
                setGender("m");
                setEconomic(["a", "b", "c", "d"]);
                setOthers(false);
                setAnyChannel(false);
                break;
            case "All Female":
                setRegion(getAllRegions());
                setAgeGroup(allAgeGroups);
                setGender("f");
                setEconomic(["a", "b", "c", "d"]);
                setOthers(false);
                setAnyChannel(false);
                break;
            case "SEC AB":
                setRegion(getAllRegions());
                setAgeGroup(allAgeGroups);
                setGender("");
                setEconomic(["a", "b"]);
                setOthers(false);
                setAnyChannel(false);
                break;
            case "SEC ABC":
                setRegion(getAllRegions());
                setAgeGroup(allAgeGroups);
                setGender("");
                setEconomic(["a", "b", "c"]);
                setOthers(false);
                setAnyChannel(false);
                break;
            case "SEC BCD":
                setRegion(getAllRegions());
                setAgeGroup(allAgeGroups);
                setGender("");
                setEconomic(["b", "c", "d"]);
                setOthers(false);
                setAnyChannel(false);
                break;
            default:
                break;
        }
    };

    const parseFilterValue = (rawValue) => {
        if (!rawValue) return null;
        if (typeof rawValue === "object") return rawValue;

        const trimmed = String(rawValue).trim();
        try {
            return JSON.parse(trimmed);
        } catch (error) {
            try {
                const normalized = trimmed
                    .replace(/:\s*"(\[.*?\])"/g, ':$1')
                    .replace(/\r?\n/g, " ")
                    .replace(/\s+/g, " ")
                    .replace(/([a-zA-Z0-9_]+)\s*:/g, '"$1":');
                return JSON.parse(normalized);
            } catch (innerError) {
                return null;
            }
        }
    };

    const normalizeRegion = (regionList = []) => {
        const list = Array.isArray(regionList) ? regionList : [regionList];
        const regionMap = {
            "dhaka": "Dhaka",
            "dhaka rural": "Dhaka Rural",
            "chattogram": "Chattogram",
            "rajshahi": "Rajshahi",
            "sylhet": "Sylhet",
            "mymensingh": "Mymensingh",
            "khulna": "Khulna",
            "rangpur": "Rangpur",
            "barishal": "Barishal"
        };
        return list.map((r) => {
            if (!r) return null;
            const key = String(r).trim().toLowerCase();
            return regionMap[key] || r;
        }).filter(Boolean);
    };

    const formatRegionForSave = (r) => {
        if (!r) return r;
        const lower = String(r).trim().toLowerCase();
        if (lower === "dhaka rural") return "dhaka Rural";
        return lower;
    };

    const normalizeAgeGroups = (groups = []) => {
        const list = Array.isArray(groups) ? groups : [groups];
        return list.map((group) => {
            if (!group) return null;
            const cleaned = String(group).replace(/\s*Yrs?\.?$/i, "").trim();
            if (cleaned === "45+" || cleaned === "45+ Years" || cleaned === "45-Above" || cleaned === "45 Above" || cleaned === "45" || cleaned === "45 & Above") {
                return "45 & Above";
            }
            return cleaned;
        }).filter(Boolean);
    };

    const normalizeGender = (genderList = []) => {
        const value = Array.isArray(genderList) ? genderList[0] : genderList;
        if (!value) return "";
        const lower = String(value).toLowerCase().trim();
        if (lower === "all") return "";
        if (lower === "male" || lower === "m") return "m";
        if (lower === "female" || lower === "f") return "f";
        return "";
    };

    const normalizeSec = (secList = []) => {
        const list = Array.isArray(secList) ? secList : [secList];
        const normalized = list.map((sec) => {
            if (!sec) return null;
            const upper = String(sec).toUpperCase().replace(/\s+/g, " ").trim();
            if (upper === "A" || upper.includes("SEC A")) return "a";
            if (upper === "B" || upper.includes("SEC B")) return "b";
            if (upper === "C" || upper.includes("SEC C")) return "c";
            if (upper === "D" || upper === "E" || upper.includes("SEC D") || upper.includes("SEC E")) return "d";
            return null;
        }).filter(Boolean);
        return normalized.length > 0 ? normalized : ["a", "b", "c", "d"];
    };

    const normalizeChannels = (channelList = []) => {
        const list = Array.isArray(channelList) ? channelList : [channelList];
        const lower = list.map((item) => String(item).toLowerCase());
        return {
            others: lower.includes("others"),
            anyChannel: lower.includes("any channel") || lower.includes("anychannel")
        };
    };

    const buildSavePayload = (filterName) => {
        const genderValue = gender === "m" ? "male" : gender === "f" ? "female" : "all";

        return {
            filter_name: filterName,
            value: {
                region: region.map(formatRegionForSave),
                ageGroup: ageGroup,
                gender: [genderValue],
                sec: economic
            }
        };
    };

    const refreshSavedFilters = (preferredName) => {
        return axiosConfig.get("/multi-tg/getFilter").then((rsp) => {
            const list = Array.isArray(rsp.data?.data) ? rsp.data.data : [];
            setSavedFilters(list);
            if (preferredName && list.length > 0) {
                const matches = list.filter((item) => item.filter_name === preferredName);
                const selected = matches.length > 0 ? matches[matches.length - 1] : null;
                if (selected) {
                    setSelectedTargetGroup(`saved_${selected.id}`);
                    applySavedFilter(selected);
                }
            }
        });
    };

    const handleSaveConfirm = () => {
        const trimmedName = saveFilterName.trim();
        if (!trimmedName) {
            setSaveError("Please enter a filter name.");
            return;
        }
        setSaveError("");
        setSaveSaving(true);
        const payload = buildSavePayload(trimmedName);
        axiosConfig
            .post("/multi-tg/saveFilter", payload)
            .then(() => refreshSavedFilters(trimmedName))
            .then(() => {
                setShowSavePopup(false);
                setSaveFilterName("");
            })
            .catch(() => {
                setSaveError("Failed to save filter. Please try again.");
            })
            .finally(() => {
                setSaveSaving(false);
            });
    };

    const isSavedFilterSelected = Boolean(selectedTargetGroup && selectedTargetGroup.startsWith("saved_"));
    const selectedFilterId = isSavedFilterSelected ? parseInt(selectedTargetGroup.replace("saved_", ""), 10) : null;
    const selectedFilterObj = savedFilters.find((item) => String(item.id) === String(selectedFilterId));

    const handleDeleteFilter = () => {
        if (!isSavedFilterSelected || !selectedFilterId) return;

        const filterName = selectedFilterObj?.filter_name || "this custom filter";
        const confirmed = window.confirm(`Are you sure you want to delete the custom filter "${filterName}"?`);
        if (!confirmed) {
            return;
        }

        setDeleteSaving(true);
        axiosConfig
            .post("/multi-tg/deleteFilter", { id: selectedFilterId })
            .then(() => {
                setSelectedTargetGroup("All");
                setRegion(getAllRegions());
                setAgeGroup(allAgeGroups);
                setGender("");
                setEconomic(["a", "b", "c", "d"]);
                setOthers(false);
                setAnyChannel(false);
                return refreshSavedFilters();
            })
            .catch((error) => {
                console.error("Failed to delete filter:", error);
                const msg = error.response?.data?.message || error.response?.data?.msg || "Failed to delete filter. Please try again.";
                alert(msg);
            })
            .finally(() => {
                setDeleteSaving(false);
            });
    };

    const applySavedFilter = (filterItem) => {
        if (!filterItem) return;
        const parsed = parseFilterValue(filterItem.value);
        if (!parsed) return;

        if (parsed.region?.length) {
            setRegion(normalizeRegion(parsed.region));
        }

        if (parsed.ageGroup?.length) {
            const normalizedAgeGroups = normalizeAgeGroups(parsed.ageGroup);
            setAgeGroup(normalizedAgeGroups);
        }

        if (parsed.gender) {
            setGender(normalizeGender(parsed.gender));
        }

        if (parsed.sec) {
            setEconomic(normalizeSec(parsed.sec));
        }

        if (parsed.channel) {
            const { others: savedOthers, anyChannel: savedAnyChannel } = normalizeChannels(parsed.channel);
            setOthers(savedOthers);
            setAnyChannel(savedAnyChannel);
        }
    };


    useEffect(() => {

        axiosConfig.get("/lastCleanedDate").then((rsp) => {
            // setCleans(rsp.data.data);
            setLastUpdatedDate(rsp.data.lastCleanedDate);

            if (rsp.data.lastCleanedDate) {
                var last_cleaned_date = new Date(rsp.data.lastCleanedDate),
                    default_start_cleanedDateWise = last_cleaned_date.getFullYear() + '-' + pad((last_cleaned_date.getMonth() + 1)) + '-01 00:00:00',
                    default_finish_cleanedDateWise = last_cleaned_date.getFullYear() + '-' + pad((last_cleaned_date.getMonth() + 1)) + '-' + pad(last_cleaned_date.getDate()) + ' 23:59:59';

                setStart(default_start_cleanedDateWise);
                setFinish(default_finish_cleanedDateWise);

                //console.log("default_start_cleanedDateWise", default_start_cleanedDateWise);
                //console.log("default_finish_cleanedDateWise", default_finish_cleanedDateWise);
            }

        }, (err) => { });

    }, [])

    useEffect(() => {
        refreshSavedFilters().catch(() => {
            setSavedFilters([]);
        });
    }, []);



    const BasicchannelDownloadfunc = () => {
        let csv = [];

        if (inputData.userType == "") {
            csv = [
                ["Graph Category-", inputData.category],
                ["Universe-", parseInt(inputData.universe)],
                ["Sample-", inputData.sample],
                ["Audience/User Type-", "All_User_type"],
                ["Time Duration-", "Start-" + modify_date(inputData.start) + "_Finish-" + modify_date(inputData.finish)],
            ];
        } else if (inputData.userType == "OTT") {
            csv = [
                ["Graph Category-", inputData.category],
                ["Universe-", parseInt(inputData.universe)],
                ["Sample-", inputData.sample],
                ["Audience/User Type-", inputData.userType],
                ["Time Duration-", "Start-" + modify_date(inputData.start) + "_Finish-" + modify_date(inputData.finish)],
            ];
        } else {
            csv = [
                ["Graph Category-", inputData.category],
                ["Universe-", parseInt(inputData.universe)],
                ["Sample-", inputData.sample],
                ["Audience/User Type-", inputData.userType || "STB"],
                ["Affected Un-Subscribed Channels:-", (inputData.blocked_channels && (inputData.blocked_channels.length > 0)) ? inputData.blocked_channels.join(", ") : ""],
                ["Foreign-", inputData.foreign == true ? "Including Foreign" : "Excluding Foreign"],
                ["Any Channel-", inputData.anyChannel == true ? "Including Any-Channel" : "Excluding Any-Channel"],
                ["Gender-", (inputData.gender ? (inputData.gender == "m" ? "Male" : "Female") : "All-Gender")],
                ["Time Duration-", "Start- " + modify_date(inputData.start) + " _ Finish- " + modify_date(inputData.finish)],
            ];

            if (inputData.region && Array.isArray(inputData.region)) {
                var mergedRegion = ["Region-", inputData.region.map((market) => market.charAt(0).toUpperCase() + market.slice(1)).join(', ')];
                csv.push(mergedRegion);
            }

            if (inputData.ageGroup && Array.isArray(inputData.ageGroup)) {
                var mergedAge = ["Age Group:", inputData.ageGroup.join(', ').replace('4-14', ' 4-14')];
                csv.push(mergedAge);
            }

            if (inputData.economic && Array.isArray(inputData.economic)) {
                var sec = [...inputData.economic];
                if (sec.includes('e')) {
                    sec.splice(sec.indexOf('e'), 1);
                }
                var mergedEconomic = ["Economic:", sec?.map((s) =>
                    s === "a"
                        ? "SEC A"
                        : s === "b"
                            ? "SEC B"
                            : s === "c"
                                ? "SEC C"
                                : "SEC D & E"
                ).join(', ')];
                csv.push(mergedEconomic);
            }
        }

        csv.push(["", ""]);

        const headers = [
            "Channel",
            "Reach(000)",
            "Reach(%)",
            "TVR(000)",
            "TVR(%)",
            "Timespent Universe(Min)",
            "Timespent Viewer(Min)",
            "Share"
        ];
        csv.push(headers);

        const channels = channelDataReachUniverse?.labels || outputData?.outputChannelName || [];
        const reach0Data = channelDataReachUniverse?.datasets?.[0]?.data || [];
        const reachPData = channelDataReachPercentage?.datasets?.[0]?.data || [];
        const tvr0Data = channelDataTVR000?.datasets?.[0]?.data || [];
        const tvrPData = channelDataTVRPercent?.datasets?.[0]?.data || [];
        const timeSpentUniData = channelDataTimeSpentUniverseMinute?.datasets?.[0]?.data || [];
        const timeSpentViewerData = channelDataTimeSpentViewer?.datasets?.[0]?.data || [];
        const shareData = channelDataTVRSharePercent?.datasets?.[0]?.data || [];

        for (let i = 0; i < channels.length; i++) {
            csv.push([
                channels[i],
                reach0Data[i] ?? "",
                reachPData[i] ?? "",
                tvr0Data[i] ?? "",
                tvrPData[i] ?? "",
                timeSpentUniData[i] ?? "",
                timeSpentViewerData[i] ?? "",
                shareData[i] ?? ""
            ]);
        }

        getCSV(csv);
    }

    function exportToCsv(filename, rows) {
        var processRow = function (row) {
            var finalVal = '';
            for (var j = 0; j < row.length; j++) {
                var innerValue = (row[j] === null || row[j] === undefined) ? '' : row[j].toString();
                if (row[j] instanceof Date) {
                    innerValue = row[j].toLocaleString();
                };
                var result = innerValue.replace(/"/g, '""');
                if (result.search(/("|,|\n)/g) >= 0)
                    result = '"' + result + '"';
                if (j > 0)
                    finalVal += ',';
                finalVal += result;
            }
            return finalVal + '\n';
        };
        var csvFile = '';
        for (var i = 0; i < rows.length; i++) {
            csvFile += processRow(rows[i]);
        }
        var blob = new Blob(["\uFEFF" + csvFile], { type: 'text/csv;charset=utf-8;' });
        if (navigator.msSaveBlob) { // IE 10+
            navigator.msSaveBlob(blob, filename);
        } else {
            var link = document.createElement("a");
            if (link.download !== undefined) { // feature detection
                // Browsers that support HTML5 download attribute
                var url = URL.createObjectURL(blob);
                link.setAttribute("href", url);
                link.setAttribute("download", filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
    var getCSV = (scsv) => {

        exportToCsv("Basic_Report(" + (inputData?.category || "All") + ").csv", scsv)

    }

    // function compareObjects(obj1, obj2) {
    //     const keys1 = Object.keys(obj1).filter(key => key !== 'category');
    //     const keys2 = Object.keys(obj2).filter(key => key !== 'category');

    //     if (keys1.length !== keys2.length) {
    //         return false;
    //     }

    //     for (const key of keys1) {
    //         if (Array.isArray(obj1[key]) && Array.isArray(obj2[key])) {
    //             if (obj1[key].length !== obj2[key].length) {
    //                 return false;
    //             }
    //             const set1 = new Set(obj1[key]);
    //             const set2 = new Set(obj2[key]);
    //             if (set1.size !== set2.size) {
    //                 return false;
    //             }
    //             for (const val of set1) {
    //                 if (!set2.has(val)) {
    //                     return false;
    //                 }
    //             }
    //         } else if (obj1[key] !== obj2[key]) {
    //             return false;
    //         }
    //     }

    //     return true;
    // }



    const GetData = () => {
        // add e in economic id d already there
        var sec = [...economic];
        //console.log(sec);
        if (sec.includes('d')) {
            sec.push('e');
        }

        var data = {
            category: "All",
            start: start,
            finish: finish,
            userType: userType,
            region: region,
            gender: gender,
            economic: sec,
            others: others,
            anyChannel: anyChannel,
            ageGroup: ageGroup,
        };


        if (start !== "" && finish !== "" && economic.length > 0 && ageGroup.length > 0 && region.length > 0 && (new Date(start).getTime() <= new Date(role_datetime).getTime()) && (new Date(finish).getTime() <= new Date(role_datetime).getTime()) && (new Date(start).getTime() <= new Date(finish).getTime())) {
            setErr("");
            setloading(false);

            console.log(data);
            axiosConfigDotNet.post("/BasicReport/basic_report_all-universe", data).then(rsp => {
                // ✅ check blocked channels here
                if (rsp.data.request.blocked_channels && rsp.data.request.blocked_channels.length > 0) {
                    alert("Affected Un-subscribed Channels: " + rsp.data.request.blocked_channels.join(", "));
                }
                setloading(true);
                setOutputData(rsp.data);
                console.log(rsp.data);

                const outVals = rsp.data.outputChannelValues || rsp.data.outputChannelValue || {};
                const labels = rsp.data.outputChannelName || [];

                const formatData = (label, values) => ({
                    labels: labels,
                    datasets: [{
                        label: label,
                        data: Array.isArray(values) ? values : [],
                        backgroundColor: ["#2a71d0"],
                        borderWidth: 1,
                        categoryPercentage: 0.9,
                        barPercentage: 1
                    }]
                });

                const reachUni = outVals.reachUniverse ?? outVals.ReachUniverse ?? rsp.data.reachUniverse ?? rsp.data.ReachUniverse ?? (Array.isArray(outVals) ? outVals : []);
                const reachP = outVals.reachPercent ?? outVals.ReachPercent ?? rsp.data.reachPercent ?? rsp.data.ReachPercent ?? [];
                const tvr0 = outVals.tvR000 ?? outVals.tvr000 ?? outVals.TVR000 ?? outVals.tvr0 ?? outVals.TVR0 ?? rsp.data.tvR000 ?? rsp.data.tvr000 ?? [];
                const tvrP = outVals.tvrPercent ?? outVals.TVRPercent ?? rsp.data.tvrPercent ?? rsp.data.TVRPercent ?? [];
                const tvrShare = outVals.tvrSharePercent ?? outVals.TVRSharePercent ?? rsp.data.tvrSharePercent ?? rsp.data.TVRSharePercent ?? [];
                const timeSpentUni = outVals.timeSpentUniverseMinute ?? outVals.TimeSpentUniverseMinute ?? rsp.data.timeSpentUniverseMinute ?? rsp.data.TimeSpentUniverseMinute ?? [];
                const timeSpentViewer = outVals.timeSpentViewerMinute ?? outVals.TimeSpentViewerMinute ?? rsp.data.timeSpentViewerMinute ?? rsp.data.TimeSpentViewerMinute ?? [];

                setChannelDataReachUniverse(formatData("Reach(000)", reachUni));
                setChannelDataReachPercentage(formatData("Reach(%)", reachP));
                setChannelDataTVR000(formatData("TVR(000)", tvr0));
                setChannelDataTVRPercent(formatData("TVR(%)", tvrP));
                setChannelDataTVRSharePercent(formatData("TVR Share(%)", tvrShare));
                setChannelDataTimeSpentUniverseMinute(formatData("Time Spent-Universe(minute)", timeSpentUni));
                setChannelDataTimeSpentViewer(formatData("Time Spent-Viewer (minute)", timeSpentViewer));

                setInputData(rsp.data.request);
                //console.log(rsp.data.request);
            }).catch(err => {

            });


        } else {
            setErr("error");
        }

    }

    var start_string = new Date(inputData.start).toLocaleString(undefined, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });
    var finish_string = new Date(inputData.finish).toLocaleString(undefined, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });



    const modify_date = (date) => {

        return new Date(date).toLocaleString(undefined, {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
        });
    }


    return (
        <div>
            <Header title="Basic Reports" />
            <MainMenu menu="basicreports" />

            <div class="app-content content">
                <div class="content-overlay"></div>
                <div className="content-wrapper" style={{ backgroundColor: "#f4f6fa" }}>
                    <div className="content-header row">
                    </div>
                    <div className="content-body">
                        <style>{`
                            .filter-panel {
                                container-type: inline-size;
                                container-name: filterpanel;
                                background: #ffffff;
                                border: 1px solid #e2e8f0;
                                border-radius: 10px;
                                box-shadow: 0 2px 10px rgba(0, 0, 0, 0.04);
                                padding: 14px 16px;
                                margin-bottom: 22px;
                            }
                            .filter-label {
                                font-size: 0.82rem;
                                font-weight: 700;
                                text-transform: uppercase;
                                letter-spacing: 0.5px;
                                color: #334155;
                                margin-bottom: 6px;
                                display: flex;
                                align-items: center;
                                justify-content: space-between;
                            }
                            .filter-label .badge {
                                color: #ffffff !important;
                                background-color: #5a8dee !important;
                                font-weight: 600 !important;
                                font-size: 0.72rem !important;
                                padding: 2px 7px !important;
                                border-radius: 10px !important;
                                letter-spacing: 0.3px;
                            }
                            .filter-box-container {
                                background: #f8fafc;
                                border: 1px solid #e2e8f0;
                                border-radius: 8px;
                                padding: 8px 10px;
                                min-height: 96px;
                                height: 100%;
                                display: flex;
                                flex-wrap: wrap;
                                align-content: flex-start;
                                gap: 5px;
                            }
                            .filter-chip {
                                display: inline-flex;
                                align-items: center;
                                gap: 4px;
                                padding: 3px 8px;
                                font-size: 0.78rem;
                                font-weight: 500;
                                border-radius: 6px;
                                border: 1px solid #cbd5e1;
                                background: #ffffff;
                                color: #334155;
                                cursor: pointer;
                                transition: all 0.15s ease-in-out;
                                user-select: none;
                                margin: 0;
                                line-height: 1.3;
                            }
                            .filter-top-row {
                                display: flex;
                                align-items: flex-end;
                                gap: 8px;
                                width: 100%;
                                flex-wrap: nowrap;
                                margin-bottom: 14px;
                            }
                            .filter-item-tg {
                                flex: 1.4 1 200px;
                                min-width: 175px;
                            }
                            .filter-item-type {
                                flex: 0 0 74px;
                                width: 74px;
                                min-width: 74px;
                            }
                            .filter-item-date {
                                flex: 1.1 1 170px;
                                min-width: 160px;
                            }
                            .filter-item-actions {
                                flex: 0 0 auto;
                            }
                            .compact-select {
                                height: 38px !important;
                                font-size: 0.90rem !important;
                                font-weight: 500 !important;
                                padding: 4px 10px !important;
                                color: #1e293b !important;
                            }
                            .compact-datetime {
                                height: 38px !important;
                                font-size: 0.88rem !important;
                                font-weight: 500 !important;
                                padding: 4px 8px !important;
                                border-radius: 6px !important;
                                border: 1px solid #cbd5e1 !important;
                                background-color: #ffffff !important;
                                color: #1e293b !important;
                                min-width: 0 !important;
                                width: 100% !important;
                                box-sizing: border-box !important;
                                letter-spacing: 0 !important;
                            }
                            .compact-datetime::-webkit-calendar-picker-indicator {
                                padding: 0;
                                margin: 0;
                                cursor: pointer;
                                filter: opacity(0.7);
                                transform: scale(0.95);
                            }
                            @container filterpanel (max-width: 680px) {
                                .filter-top-row {
                                    flex-wrap: wrap;
                                    gap: 8px;
                                }
                                .filter-item-tg {
                                    flex: 1 1 calc(100% - 82px);
                                    min-width: 0;
                                }
                                .filter-item-type {
                                    flex: 0 0 74px;
                                }
                                .filter-item-date {
                                    flex: 1 1 calc(50% - 4px);
                                    min-width: 140px;
                                }
                                .filter-item-actions {
                                    flex: 1 1 100%;
                                }
                                .filter-item-actions > div {
                                    width: 100%;
                                    display: flex;
                                }
                                .filter-item-actions button {
                                    flex: 1;
                                }
                            }
                            @media (max-width: 820px) {
                                .filter-top-row {
                                    flex-wrap: wrap;
                                    gap: 8px;
                                }
                                .filter-item-tg {
                                    flex: 1 1 calc(100% - 82px);
                                    min-width: 0;
                                }
                                .filter-item-type {
                                    flex: 0 0 74px;
                                }
                                .filter-item-date {
                                    flex: 1 1 calc(50% - 4px);
                                    min-width: 140px;
                                }
                                .filter-item-actions {
                                    flex: 1 1 100%;
                                }
                                .filter-item-actions > div {
                                    width: 100%;
                                    display: flex;
                                }
                                .filter-item-actions button {
                                    flex: 1;
                                }
                            }
                            input[type="datetime-local"] {
                                min-width: 0;
                                width: 100%;
                            }
                            .filter-chip:hover:not(.disabled) {
                                border-color: #0284c7;
                                background: #f0f9ff;
                                color: #0369a1;
                            }
                            .filter-chip.active {
                                background: #e0f2fe;
                                border-color: #0284c7;
                                color: #0369a1;
                                font-weight: 600;
                                box-shadow: 0 1px 2px rgba(2, 132, 199, 0.15);
                            }
                            .filter-chip.disabled {
                                opacity: 0.45;
                                cursor: not-allowed;
                                background: #f1f5f9;
                                border-color: #e2e8f0;
                                color: #94a3b8;
                            }
                            .filter-chip input[type="checkbox"] {
                                cursor: pointer;
                                accent-color: #0284c7;
                                width: 13px;
                                height: 13px;
                                margin: 0;
                            }
                            .segmented-group {
                                display: flex;
                                background: #f1f5f9;
                                border: 1px solid #e2e8f0;
                                border-radius: 8px;
                                padding: 3px;
                                gap: 3px;
                            }
                            .segmented-btn {
                                flex: 1;
                                text-align: center;
                                padding: 5px 6px;
                                font-size: 0.8rem;
                                font-weight: 500;
                                border-radius: 6px;
                                cursor: pointer;
                                border: none;
                                background: transparent;
                                color: #64748b;
                                transition: all 0.15s ease-in-out;
                                user-select: none;
                                margin: 0;
                            }
                            .segmented-btn:hover:not(.active) {
                                color: #0f172a;
                                background: rgba(255,255,255,0.7);
                            }
                            .segmented-btn.active {
                                background: #ffffff;
                                color: #0284c7;
                                font-weight: 600;
                                box-shadow: 0 1px 3px rgba(0,0,0,0.08);
                            }
                        `}</style>

                        <div className="filter-panel">
                            {/* Top Control Bar: Target Group (with Save/Delete), Platform Type, Date Range & Actions */}
                            <div className="filter-top-row">
                                <div className="filter-item-tg">
                                    <label className="filter-label">
                                        <span>Target Group</span>
                                        {isSavedFilterSelected && (
                                            <span className="badge badge-info font-weight-normal" style={{ fontSize: "0.74rem", padding: "2px 6px" }}>Custom</span>
                                        )}
                                    </label>
                                    <div className="input-group">
                                        <select
                                            className="custom-select form-control compact-select"
                                            value={selectedTargetGroup}
                                            onChange={handleTargetGroupChange}
                                            style={{ borderRadius: "6px 0 0 6px" }}
                                        >
                                            <optgroup label="Predefined Target Groups">
                                                <option value="All">All</option>
                                                <option value="All Urban">All Urban</option>
                                                <option value="All Rural">All Rural</option>
                                                <option value="All 15+">All 15+</option>
                                                <option value="All Male">All Male</option>
                                                <option value="All Female">All Female</option>
                                                <option value="SEC AB">SEC AB</option>
                                                <option value="SEC ABC">SEC ABC</option>
                                                <option value="SEC BCD">SEC BCD</option>
                                            </optgroup>
                                            {savedFilters.length > 0 && (
                                                <optgroup label="Saved Filters">
                                                    {savedFilters.map((filter) => (
                                                        <option key={filter.id} value={`saved_${filter.id}`}>
                                                            {filter.filter_name}
                                                        </option>
                                                    ))}
                                                </optgroup>
                                            )}
                                        </select>
                                        <div className="input-group-append">
                                            <button
                                                type="button"
                                                className="btn btn-outline-success"
                                                style={{
                                                    fontWeight: "600",
                                                    height: "38px",
                                                    borderRadius: "0",
                                                    fontSize: "0.82rem",
                                                    padding: "0 11px"
                                                }}
                                                onClick={() => {
                                                    setSaveFilterName("");
                                                    setSaveError("");
                                                    setShowSavePopup(true);
                                                }}
                                                title="Save current filter settings as a custom Target Group"
                                            >
                                                Save
                                            </button>
                                            <button
                                                type="button"
                                                className={`btn ${isSavedFilterSelected ? "btn-outline-danger" : "btn-outline-secondary"}`}
                                                style={{
                                                    fontWeight: "600",
                                                    height: "38px",
                                                    borderRadius: "0 6px 6px 0",
                                                    fontSize: "0.82rem",
                                                    padding: "0 11px",
                                                    opacity: isSavedFilterSelected ? 1 : 0.5,
                                                    cursor: isSavedFilterSelected ? "pointer" : "not-allowed"
                                                }}
                                                onClick={() => {
                                                    if (!isSavedFilterSelected) {
                                                        alert("Please select a saved custom filter from the Target Group dropdown first to delete.");
                                                        return;
                                                    }
                                                    handleDeleteFilter();
                                                }}
                                                disabled={deleteSaving}
                                                title={isSavedFilterSelected ? "Delete selected custom filter" : "Select a saved custom filter from the Target Group dropdown to delete"}
                                            >
                                                {deleteSaving ? "..." : "Delete"}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div className="filter-item-type">
                                    <label className="filter-label">
                                        Type
                                    </label>
                                    <select
                                        className="custom-select form-control compact-select"
                                        disabled
                                        value={userType}
                                        onChange={(e) => { setUserType(e.target.value) }}
                                        style={{ borderRadius: "6px", padding: "0 6px" }}
                                    >
                                        <option value="">All</option>
                                        <option value="STB">STB</option>
                                        <option value="OTT">OTT</option>
                                    </select>
                                </div>

                                <div className="filter-item-date">
                                    <label className="filter-label" htmlFor="dateTime1">
                                        Start Time
                                    </label>
                                    <input
                                        type="datetime-local"
                                        className="form-control compact-datetime"
                                        id="dateTime1"
                                        step="60"
                                        value={start ? new Date(start + 'Z').toISOString().slice(0, -8) : ""}
                                        onChange={(e) => { setStart(e.target.value + ':00') }}
                                    />
                                </div>

                                <div className="filter-item-date">
                                    <label className="filter-label" htmlFor="dateTime2">
                                        Finish Time
                                    </label>
                                    <input
                                        type="datetime-local"
                                        className="form-control compact-datetime"
                                        id="dateTime2"
                                        step="60"
                                        value={finish ? new Date(finish + 'Z').toISOString().slice(0, -8) : ""}
                                        onChange={(e) => { setFinish(e.target.value + ':59') }}
                                    />
                                </div>

                                <div className="filter-item-actions">
                                    <label className="filter-label d-none d-md-block" style={{ visibility: "hidden" }}>
                                        Actions
                                    </label>
                                    <div className="d-flex align-items-center" style={{ gap: "6px" }}>
                                        <button
                                            onClick={GetData}
                                            className="btn btn-primary shadow-sm"
                                            style={{
                                                fontWeight: "600",
                                                borderRadius: "6px",
                                                height: "38px",
                                                padding: "0 14px",
                                                fontSize: "0.88rem",
                                                whiteSpace: "nowrap"
                                            }}
                                        >
                                            View
                                        </button>
                                        <button
                                            type="button"
                                            onClick={loading && err !== "error" ? BasicchannelDownloadfunc : undefined}
                                            disabled={!loading || err === "error"}
                                            className={`btn ${loading && err !== "error" ? "btn-danger shadow-sm" : "btn-secondary"}`}
                                            style={{
                                                fontWeight: "600",
                                                borderRadius: "6px",
                                                height: "38px",
                                                padding: "0 12px",
                                                fontSize: "0.84rem",
                                                whiteSpace: "nowrap",
                                                opacity: loading && err !== "error" ? 1 : 0.5,
                                                cursor: loading && err !== "error" ? "pointer" : "not-allowed",
                                                border: loading && err !== "error" ? undefined : "1px solid #cbd5e1",
                                                backgroundColor: loading && err !== "error" ? undefined : "#e2e8f0",
                                                color: loading && err !== "error" ? undefined : "#64748b"
                                            }}
                                            title={loading && err !== "error" ? "Download CSV Report" : "Click 'View' to generate graph before downloading CSV"}
                                        >
                                            Download CSV
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <hr style={{ borderColor: "#edf2f7", margin: "14px 0 16px 0" }} />

                            {/* Tier 3: Region, Age Group, SEC, Gender & Channels */}
                            <div className="row">
                                {/* Region (4 cols on lg/xl, 12 on md) */}
                                <div className="col-xl-4 col-lg-4 col-md-12 mb-3 mb-lg-0 d-flex flex-column">
                                    <label className="filter-label">
                                        <span>Region</span>
                                        <span className="badge badge-primary font-weight-normal" style={{ color: "#ffffff" }}>{region.length} selected</span>
                                    </label>
                                    <div className="filter-box-container">
                                        <label className={`filter-chip ${region.includes("Dhaka") ? "active" : ""}`}>
                                            <input type="checkbox" value="Dhaka" checked={region.includes("Dhaka")} onChange={handleCheckboxChangeRegion} />
                                            Dhaka
                                        </label>
                                        <label className={`filter-chip ${region.includes("Dhaka Rural") ? "active" : ""} ${dhakaRural_isRegionDisabled ? "disabled" : ""}`}>
                                            <input
                                                type="checkbox"
                                                value="Dhaka Rural"
                                                checked={region.includes("Dhaka Rural")}
                                                onChange={handleCheckboxChangeRegion}
                                                disabled={dhakaRural_isRegionDisabled}
                                            />
                                            Dhaka Rural
                                        </label>
                                        <label className={`filter-chip ${region.includes("Chattogram") ? "active" : ""}`}>
                                            <input type="checkbox" value="Chattogram" checked={region.includes("Chattogram")} onChange={handleCheckboxChangeRegion} />
                                            Chattogram
                                        </label>
                                        <label className={`filter-chip ${region.includes("Rajshahi") ? "active" : ""} ${isRegionDisabled ? "disabled" : ""}`}>
                                            <input
                                                type="checkbox"
                                                value="Rajshahi"
                                                checked={region.includes("Rajshahi")}
                                                onChange={handleCheckboxChangeRegion}
                                                disabled={isRegionDisabled}
                                            />
                                            Rajshahi
                                        </label>
                                        <label className={`filter-chip ${region.includes("Sylhet") ? "active" : ""} ${isRegionDisabled ? "disabled" : ""}`}>
                                            <input
                                                type="checkbox"
                                                value="Sylhet"
                                                checked={region.includes("Sylhet")}
                                                onChange={handleCheckboxChangeRegion}
                                                disabled={isRegionDisabled}
                                            />
                                            Sylhet
                                        </label>
                                        <label className={`filter-chip ${region.includes("Mymensingh") ? "active" : ""} ${isRegionDisabled ? "disabled" : ""}`}>
                                            <input
                                                type="checkbox"
                                                value="Mymensingh"
                                                checked={region.includes("Mymensingh")}
                                                onChange={handleCheckboxChangeRegion}
                                                disabled={isRegionDisabled}
                                            />
                                            Mymensingh
                                        </label>
                                        <label className={`filter-chip ${region.includes("Khulna") ? "active" : ""} ${isRegionDisabled ? "disabled" : ""}`}>
                                            <input
                                                type="checkbox"
                                                value="Khulna"
                                                checked={region.includes("Khulna")}
                                                onChange={handleCheckboxChangeRegion}
                                                disabled={isRegionDisabled}
                                            />
                                            Khulna
                                        </label>
                                        <label className={`filter-chip ${region.includes("Rangpur") ? "active" : ""} ${isRegionDisabled ? "disabled" : ""}`}>
                                            <input
                                                type="checkbox"
                                                value="Rangpur"
                                                checked={region.includes("Rangpur")}
                                                onChange={handleCheckboxChangeRegion}
                                                disabled={isRegionDisabled}
                                            />
                                            Rangpur
                                        </label>
                                        <label className={`filter-chip ${region.includes("Barishal") ? "active" : ""} ${isRegionDisabled ? "disabled" : ""}`}>
                                            <input
                                                type="checkbox"
                                                value="Barishal"
                                                checked={region.includes("Barishal")}
                                                onChange={handleCheckboxChangeRegion}
                                                disabled={isRegionDisabled}
                                            />
                                            Barishal
                                        </label>
                                    </div>
                                </div>

                                {/* Age Group (3 cols) */}
                                <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6 mb-3 mb-lg-0 d-flex flex-column">
                                    <label className="filter-label">
                                        <span>Age Group</span>
                                        <span className="badge badge-primary font-weight-normal" style={{ color: "#ffffff" }}>{ageGroup.length} selected</span>
                                    </label>
                                    <div className="filter-box-container">
                                        <label className={`filter-chip ${ageGroup.includes("4-14") ? "active" : ""}`}>
                                            <input type="checkbox" value="4-14" checked={ageGroup.includes("4-14")} onChange={handleCheckboxChangeAgeGroup} />
                                            4-14 Yrs
                                        </label>
                                        <label className={`filter-chip ${ageGroup.includes("15-24") ? "active" : ""}`}>
                                            <input type="checkbox" value="15-24" checked={ageGroup.includes("15-24")} onChange={handleCheckboxChangeAgeGroup} />
                                            15-24 Yrs
                                        </label>
                                        <label className={`filter-chip ${ageGroup.includes("25-34") ? "active" : ""}`}>
                                            <input type="checkbox" value="25-34" checked={ageGroup.includes("25-34")} onChange={handleCheckboxChangeAgeGroup} />
                                            25-34 Yrs
                                        </label>
                                        <label className={`filter-chip ${ageGroup.includes("35-44") ? "active" : ""}`}>
                                            <input type="checkbox" value="35-44" checked={ageGroup.includes("35-44")} onChange={handleCheckboxChangeAgeGroup} />
                                            35-44 Yrs
                                        </label>
                                        <label className={`filter-chip ${ageGroup.includes("45 & Above") ? "active" : ""}`}>
                                            <input type="checkbox" value="45 & Above" checked={ageGroup.includes("45 & Above")} onChange={handleCheckboxChangeAgeGroup} />
                                            45 & Above
                                        </label>
                                    </div>
                                </div>

                                {/* SEC (2 cols) */}
                                <div className="col-xl-2 col-lg-2 col-md-4 col-sm-6 mb-3 mb-lg-0 d-flex flex-column">
                                    <label className="filter-label">
                                        <span>SEC</span>
                                        <span className="badge badge-primary font-weight-normal" style={{ color: "#ffffff" }}>{economic.length} selected</span>
                                    </label>
                                    <div className="filter-box-container">
                                        <label className={`filter-chip ${economic.includes("a") ? "active" : ""}`}>
                                            <input type="checkbox" value="a" checked={economic.includes("a")} onChange={handleCheckboxChangeEconomic} />
                                            SEC A
                                        </label>
                                        <label className={`filter-chip ${economic.includes("b") ? "active" : ""}`}>
                                            <input type="checkbox" value="b" checked={economic.includes("b")} onChange={handleCheckboxChangeEconomic} />
                                            SEC B
                                        </label>
                                        <label className={`filter-chip ${economic.includes("c") ? "active" : ""}`}>
                                            <input type="checkbox" value="c" checked={economic.includes("c")} onChange={handleCheckboxChangeEconomic} />
                                            SEC C
                                        </label>
                                        <label className={`filter-chip ${economic.includes("d") ? "active" : ""}`}>
                                            <input type="checkbox" value="d" checked={economic.includes("d")} onChange={handleCheckboxChangeEconomic} />
                                            SEC D & E
                                        </label>
                                    </div>
                                </div>

                                {/* Gender & Channels (3 cols) */}
                                <div className="col-xl-3 col-lg-3 col-md-4 col-12 d-flex flex-column">
                                    <label className="filter-label">
                                        Gender
                                    </label>
                                    <div className="segmented-group mb-2">
                                        <button
                                            type="button"
                                            className={`segmented-btn ${gender === "" ? "active" : ""}`}
                                            onClick={() => setGender("")}
                                        >
                                            All
                                        </button>
                                        <button
                                            type="button"
                                            className={`segmented-btn ${gender === "m" ? "active" : ""}`}
                                            onClick={() => setGender("m")}
                                        >
                                            Male
                                        </button>
                                        <button
                                            type="button"
                                            className={`segmented-btn ${gender === "f" ? "active" : ""}`}
                                            onClick={() => setGender("f")}
                                        >
                                            Female
                                        </button>
                                    </div>

                                    <label className="filter-label mt-1">
                                        Channels
                                    </label>
                                    <div className="d-flex" style={{ gap: "6px" }}>
                                        <label className={`filter-chip flex-fill justify-content-center ${others ? "active" : ""}`}>
                                            <input type="checkbox" checked={others} onChange={() => setOthers(!others)} />
                                            Others
                                        </label>
                                        <label className={`filter-chip flex-fill justify-content-center ${anyChannel ? "active" : ""}`}>
                                            <input type="checkbox" checked={anyChannel} onChange={() => setAnyChannel(!anyChannel)} />
                                            Any
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>



                        <div class="row justify-content-md-center">
                            <div class="col">
                                {/* <PostGraph title="Active Users" text="Active Channels" url="reach/percent" label="Active Users" color="blue" credentials={credential} /> */}

                                {(() => {
                                    if (err === "error") {
                                        return (
                                            <div class="card">
                                                <div class="card-header">
                                                    <div class="h2 card-title text-warning font-weight-bold">Please enter a valid date until <span class="text-primary bold"> {modify_date(role_datetime)}</span> & other inputs also.</div>

                                                </div>
                                                <div class="card-body collapse show">


                                                </div>
                                            </div>
                                        )
                                    } else {

                                        if (loading) {
                                            const graphConfigs = [
                                                { title: "Channels Reach (000)", data: channelDataReachUniverse },
                                                { title: "Channels Reach (%)", data: channelDataReachPercentage },
                                                { title: "Channels TVR (000)", data: channelDataTVR000 },
                                                { title: "Channels TVR (%)", data: channelDataTVRPercent },
                                                { title: "Channels TVR Share (%)", data: channelDataTVRSharePercent },
                                                { title: "Channels Time Spent (Uni) (Minute)", data: channelDataTimeSpentUniverseMinute },
                                                { title: "Channels Time Spent -Viewer (Minute)", data: channelDataTimeSpentViewer }
                                            ];

                                            return (
                                                <div class="card">
                                                    {graphConfigs.map((g, idx) => (
                                                        <React.Fragment key={idx}>
                                                            <div class="card-header">
                                                                <div class="row">
                                                                    <div class="col-6 h2 card-title font-weight-bold">
                                                                        {g.title} <p><small>Universe (000): {parseInt(inputData.universe)} <br></br> Sample: {inputData.sample}</small></p>
                                                                    </div>
                                                                    <div class="row col h2 card-title text-left">
                                                                        From [<p class="text-primary bold"> {start_string}</p>] to [<p class="text-primary bold">{finish_string}</p>]
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="card-body collapse show" style={{ height: "35em" }}>
                                                                <Bar data={g.data} options={barOptions} />
                                                            </div>
                                                        </React.Fragment>
                                                    ))}
                                                </div>
                                            )


                                        } else {
                                            return (
                                                <div class="card">
                                                    <div class="card-header">
                                                        <div class="row"><div class="col-6 h2 card-title font-weight-bold">Loading Graphs...</div></div>

                                                    </div>
                                                    <div class="card-body collapse show" style={{ height: "35em" }}>

                                                        <img src="https://upload.wikimedia.org/wikipedia/commons/c/c7/Loading_2.gif?20170503175831" class="rounded mx-auto d-block" alt="..." />


                                                    </div>
                                                </div>

                                            )

                                        }


                                    }
                                })()}



                            </div>
                        </div>
                    </div>

                </div>
            </div>

            {showSavePopup && (
                <div class="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }} role="dialog" aria-modal="true">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Save Filter</h5>
                                <button
                                    type="button"
                                    class="close"
                                    aria-label="Close"
                                    onClick={() => {
                                        if (!saveSaving) {
                                            setShowSavePopup(false);
                                            setSaveError("");
                                        }
                                    }}
                                >
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="form-group">
                                    <label>Filter Name</label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        value={saveFilterName}
                                        onChange={(e) => setSaveFilterName(e.target.value)}
                                        placeholder="Enter a name"
                                    />
                                    {saveError && <div class="text-danger mt-1">{saveError}</div>}
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-secondary"
                                    onClick={() => {
                                        if (!saveSaving) {
                                            setShowSavePopup(false);
                                            setSaveError("");
                                        }
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-primary"
                                    onClick={handleSaveConfirm}
                                    disabled={saveSaving}
                                >
                                    {saveSaving ? "Saving..." : "Confirm"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>

    )
}
export default OverviewOPT;